// extracted by mini-css-extract-plugin
module.exports = {"DropArea":"ImageUpload_DropArea__SgX3q","Icon":"ImageUpload_Icon__1PVFS","dropped":"ImageUpload_dropped__PNzcg"};